export default __webpack_public_path__ + "static/media/Twenty2.32c7ccd4.jpeg";